/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:30
 */
const s = {
    ballDistance: 19.2,
    diameter: 6.7,
    numRows: 14,
    yMult: 1.13,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [228.18343986757156, 199.56136336735375, 202.28312340821824, 200.1117369459881, 226.68371249072985, 199.9977000662761, 199.5116723356763, 227.98092662057925],
        1: [199.70145996954096, 202.60023275651812, 201.47193908375695, 228.18189628931125, 226.10026053162184, 228.60700519699063, 202.215974972114, 228.7585619678625],
        2: [202.59851065652362, 199.4852338980126, 227.8426723605489, 202.0485678145185, 228.11576740589936, 201.12589496852968, 199.5140789344198, 199.79273230716288],
        3: [200.8673095524007, 200.16186374402614, 199.9039215029045, 199.31602102340602, 228.66241015516005, 200.9389852889307, 199.78718668097468, 226.48091010131506],
        4: [228.2121346817533, 226.265141520945, 201.51876300123945, 199.50055510314903, 228.4362598475249, 226.3273323599267, 228.9160724866826, 200.00933609196412],
        5: [199.77788861295957, 199.23338777712874, 226.4977603055371, 226.2566372971209, 200.17329284168383, 227.3770351073202, 200.86995191254846, 228.63310999150156],
        6: [202.5907066580927, 227.93854762091863, 228.75629561758723, 228.14414519283315, 228.4543978333002, 225.80377803569877, 201.9173338510569, 225.39364157866726],
        7: [201.95038442196986, 199.4907694374605, 225.58219613161603, 200.26466774080663, 199.66299597072168, 199.64213814027883, 227.72771787103466, 226.29155684382647],
        8: [200.23120522816268, 225.58657442298772, 199.22471179054762, 202.3844855568947, 199.37024487385963, 199.9800437949458, 226.39499995845475, 227.91323379224093],
        9: [201.53862523281995, 227.8508677986999, 201.31700609699473, 225.73898595229858, 226.37488838055967, 228.50962057558252, 227.89081407715236, 228.60691557516978],
        10: [228.21929159598565, 202.62042130445127, 225.59104476215583, 225.42712131079762, 201.30544278828805, 201.56690529200395, 228.72140185970136, 225.91908538555563],
        11: [228.50640972516925, 200.89098876843394, 202.38553037493764, 225.68581593469312, 227.37536503965185, 201.64854504159155, 228.45941178136954, 202.01536389555577],
        12: [225.9685819360249, 228.2630240286205, 201.01049829701518, 202.5919159777619, 201.56213924703715, 225.73639666359884, 227.3626597462604, 202.3613715867216],
        13: [202.40135846795613, 225.9309729378253, 201.91571159062164, 225.70319427697962, 228.24620431273937, 200.15495493517486, 200.11271783275137, 200.88082193747908],
        14: [228.388003521124, 201.71327738671656, 228.77554808972576, 227.7183430095454, 201.46125836607087, 228.3869227079509, 226.0467579638372, 201.31627586072392],
        15: []
    }
};
export {s as default};
